/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
  {
    id: 'hqPTy6ExHB',
    title: 'Opna Womens Short Sleeve Moisture',
    price: 2000,
    category: 'womens',
    outofStock: false,
    rating: '4.5',
    description:
      '100% Polyester, Machine wash, 100% cationic polyester interlock, Machine Wash & Pre Shrunk for a Great Fit, Lightweight, roomy and highly breathable with moisture wicking fabric which helps to keep moisture away, Soft Lightweight Fabric with comfortable V-neck collar and a slimmer fit, delivers a sleek, more feminine silhouette and Added Comfort',
    image: 'https://i.postimg.cc/0jPJ8kc5/51eg55u-Wmd-L-AC-UX679.png',
  },
  {
    id: '3ppeqULDXn',
    title: 'BIYLACLESEN Womens 3-in-1 Snowboard Jacket Winter Coats',
    price: 4800,
    category: 'womens',
    outofStock: false,
    rating: '2.6',
    description:
      'Note:The Jackets is US standard size, Please choose size as your usual wear Material: 100% Polyester; Detachable Liner Fabric: Warm Fleece. Detachable Functional Liner: Skin Friendly, Lightweigt and Warm.Stand Collar Liner jacket, keep you warm in cold weather. Zippered Pockets: 2 Zippered Hand Pockets, 2 Zippered Pockets on Chest (enough to keep cards or keys)and 1 Hidden Pocket Inside.Zippered Hand Pockets and Hidden Pocket keep your things secure. Humanized Design: Adjustable and Detachable Hood and Adjustable cuff to prevent the wind and water,for a comfortable fit. 3 in 1 Detachable Design provide more convenience, you can separate the coat and inner as needed, or wear it together. It is suitable for different season and help you adapt to different climates',
    image: 'https://i.postimg.cc/NfPLnkqj/51-Y5-NI-I5j-L-AC-UX679.png',
  },
  {
    id: 'x0h5P1yp1z',
    title: 'Lock and Love Womens Removable Hooded Faux Leather Moto Biker Jacket',
    price: 1200,
    category: 'womens',
    outofStock: false,
    rating: '2.9',
    description:
      '100% POLYURETHANE(shell) 100% POLYESTER(lining) 75% POLYESTER 25% COTTON (SWEATER), Faux leather material for style and comfort / 2 pockets of front, 2-For-One Hooded denim style faux leather jacket, Button detail on waist / Detail stitching at sides, HAND WASH ONLY / DO NOT BLEACH / LINE DRY / DO NOT IRON',
    image: 'https://i.postimg.cc/7ZkPdstD/81-XH0e8fef-L-AC-UY879.png',
  },
  {
    id: '6Lxfbi0pOe',
    title: 'Rain Jacket Women Windbreaker Striped Climbing Raincoats',
    price: 1899,
    category: 'womens',
    outofStock: false,
    rating: '3.8',
    description:
      'Lightweight perfet for trip or casual wear---Long sleeve with hooded, adjustable drawstring waist design. Button and zipper front closure raincoat, fully stripes Lined and The Raincoat has 2 side pockets are a good size to hold all kinds of things, it covers the hips, and the hood is generous but does not overdo it.Attached Cotton Lined Hood with Adjustable Drawstrings give it a real styled look.',
    image: 'https://i.postimg.cc/43FgfBPY/71-Hbl-AHs5x-L-AC-UY879-2.png',
  },
  {
    id: 'Dt5YgwZUUR',
    title: 'MBJ Womens Solid Short Sleeve Boat Neck V',
    price: 3200,
    category: 'womens',
    outofStock: false,
    rating: '4.7',
    description:
      '95% RAYON 5% SPANDEX, Made in USA or Imported, Do Not Bleach, Lightweight fabric with great stretch for comfort, Ribbed on sleeves and neckline / Double stitching on bottom hem',
    image: 'https://i.postimg.cc/MKYgZ9Kz/71z3kp-MAYs-L-AC-UY879.png',
  },
  {
    id: 'hUrBabVvTP',
    title: 'DANVOUY Womens T Shirt Casual Cotton Short',
    price: 990,
    category: 'womens',
    outofStock: false,
    rating: '3.6',
    description:
      '95%Cotton,5%Spandex, Features: Casual, Short Sleeve, Letter Print,V-Neck,Fashion Tees, The fabric is soft and has some stretch., Occasion: Casual/Office/Beach/School/Home/Street. Season: Spring,Summer,Autumn,Winter.',
    image: 'https://i.postimg.cc/xCcb8pSh/61p-HAEJ4-NML-AC-UX679.png',
  },
  {
    id: 'oVyNtZgRE7',
    title: 'Mens Cotton Jacket',
    price: 3400,
    category: 'mens',
    outofStock: false,
    rating: '4.7',
    description:
      'great outerwear jackets for Spring/Autumn/Winter, suitable for many occasions, such as working, hiking, camping, mountain/rock climbing, cycling, traveling or other outdoors. Good gift choice for you or your family member. A warm hearted love to Father, husband or son in this thanksgiving or Christmas Day.',
    image: 'https://i.postimg.cc/T33bB34T/71li-ujtl-UL-AC-UX679.png',
  },
  {
    id: 'roqMUaFf7e',
    title: 'Zombom Men Cotton Polyester Blend Regular Fit Shirt',
    price: 799,
    category: 'mens',
    outofStock: false,
    rating: '4.0',
    description:
      'Zomboms Casual Shirt is the perfect pick for a casual, yet classy expression. Made of cotton polyester blend, the fabric is soft on the skin to provide all day comfort. It features a curved hemline and offers a relaxing fit that accentuates a neat look. Whatever the occasion, exude confidence in style with this fashionable shirt. Soft and comfortable to wear, the fabric is breathable and easy on the skin- providing a cool effect to keep you relaxed throughout the day. You can go casual and keep it outside or go formal and tuck it in. The casual shirt from ZOMBOM is tailored to offer a regular and smart fit. These shirts are stitched in our own factory with care. ',
    image: 'https://i.postimg.cc/pTKymmTb/51t5kzudc-GL-UY879.png',
  },
  {
    id: 'zNSxCvWCKy',
    title: 'Mens Casual Slim Fit',
    price: 1460,
    category: 'mens',
    outofStock: false,
    rating: '4.5',
    description:
      'The color could be slightly different between on the screen and in practice. / Please note that body builds vary by person, therefore, detailed size information should be reviewed below on the product description.',
    image: 'https://i.postimg.cc/Hn2GKgS7/71-YXze-Ousl-L-AC-UY879.png',
  },
  {
    id: '2s693TeOhM',
    title: 'FASHION GALLERY Mens Regular Jacket',
    price: 2300,
    category: 'mens',
    outofStock: false,
    rating: '3.0',
    description:
      'FASHION GALLERY is a large store of collection of Jackets with the most popular and trending designs so that our customer gets up with an excellent choice. The customer would be happy after getting the product in their hands. Why buy from FASHION GALLERY: We have the variety of top selling tshirts with regular fitting type . Competitive Prices for the customers as we are manufacturers. Quality: The only but not the least is that we serves our customers with the excellent quality of products . Our Jackets are made up of good quality of fleece. Delivery Assuranse: We love to deliver our products to the customer quickly (we dispatch the product on the same day that customer order). At last we have only one thing to say that we only have products that are MADE IN INDIA as we love to share our Indian products only. " Search Terms: jackets, jackets for mens, mens jackets, fleece jackets, sweatshirts, sweatshirts for men, stylish winter jackets, winter jackets for men, hooded jackets, jackets for mens stylish, winter jackets for men, mens hooded sweatshirt',
    image: 'https://i.postimg.cc/tTBYHLv8/318-C8k-Qaps-L.png',
  },
  {
    id: 'XW3ecOQqmU',
    title: 'Mens Casual Premium Slim Fit Shirt',
    price: 999,
    category: 'mens',
    outofStock: false,
    rating: '4.1',
    description:
      'Slim-fitting style, contrast raglan long sleeve, three-button henley placket, light weight & soft fabric for breathable and comfortable wearing. And Solid stitched shirts with round neck made for durability and a great fit for casual fashion wear and diehard baseball fans. The Henley style round neckline includes a three-button placket.',
    image: 'https://i.postimg.cc/0QptNC1Y/61iy-WVZ7z-UL-UY879.png',
  },
  {
    id: 'EBoC1XrC7l',
    title: 'Creative concepts Mens Slim fit Casual Waistcoat',
    price: 2200,
    category: 'mens',
    outofStock: false,
    rating: '3.8',
    description:
      'Two Cuts At Back Occassions Party & Casual Wear grey Cotton Fabric Size Guide Blazer&Waistcoat Size Should Be "6" Inch Over Your Jeans Waist Size (For Eg : If You Wear "30" Size Jeans Your Blazer Size Should Be "36") Verify The Size chart Of creative concepts Before Placing Order',
    image: 'https://i.postimg.cc/yNxZ8m2D/51-Boxa-H7-Je-L.png',
  },
  {
    id: 'WhEJnyIjqd',
    title: 'Noise Buds VS201 V2',
    price: 1299,
    category: 'earphone',
    outofStock: false,
    rating: '4.0',
    description:
      'Dual equalizer: Enjoy your music the way you like it. Switch between bass or normal mode to get the best sound. Crystal clear calls: Want an easy work from home experience? Individual mic in each earbud has got you covered. Buds VS201 offer a play time of up to 4.5 hours on a single charge and an additional 9.5 hours making a total playtime of up to 14 hours with the charging case. Full touch controls: Manage your calls, change tracks, activate your preferred voice assistant and more with the touch controls on the earbuds. Designed for all-day wear, the ergonomic design ensures you get the comfort fit throughout the day. Bluetooth v5.1: Experience lag-free usage, thanks to the industry-leading Bluetooth v5.1.',
    image: 'https://i.postimg.cc/nhvcTLgc/61xft-ZKXvw-L-AC-UL480-FMwebp-QL65.png',
  },
  {
    id: '5bUBdjL637',
    title: 'JBL Tune 230NC TWS',
    price: 5290,
    category: 'earphone',
    rating: '4.5',
    description:
      'The Active Noise Cancelling technology with 4 mics on the earbud lets you minimize audio distractions. Keep the music going and never miss a beat with 40 (30+10) hours of playtime with Bluetooth (ANC OFF). Enjoying your music with ANC ON provides you playtime of 8 Hours on the earbuds and 24 Hours from the case. Customize your Tune 230NC listening experience with JBL Headphones App. Do more, be it Customizing your NC Setttings, Gesture Controls, EQ Settings, Finding your earbuds or configuring your Voice Assistant. Enjoy hassle-free, hands-free calls in stereo. The Tune 230NC TWS are equipped with 4 microphones, so you’ll always be heard with perfect clarity. When dry on power, a quick 10 minutes of charging provides you with upto 2 Hours of playtime, while you can completely charge from Zero to 100 within 2 Hours. Smartly designed 6 mm drivers enhanced by the Dot form factor deliver JBL’s Pure Bass Sound so you’ll feel every pulsing beat.',
    image: 'https://i.postimg.cc/rw3FNP8c/51creyl-SFEL-AC-UL480-FMwebp-QL65.png',
  },
  {
    id: 'JN8tiiDsCM',
    title: 'Oppo Enco M32 Bluetooth Wireless Earbuds with Mic',
    price: 1599,
    category: 'earphone',
    rating: '3.0',
    description:
      '10 Minutes Charge -20 Hours Music Playback. 28Hours Battery Life on full charge, 0-100% charge in 35mins. 10mm Large driver, TPU+PET composite titanium-plated diaphragm Faster and more stable connection & lower deterioration Split earbuds to turn on and stick to shut down/ pause playback. To switch between the connected devices with just a click',
    image: 'https://i.postimg.cc/66FXSGkL/518ti3ya2-YL-AC-UL480-FMwebp-QL65.png',
  },
  {
    id: 'https://i.postimg.cc/Hx2rz9Z2/51-AMqyp-sf-L-AC-UL480-FMwebp-QL65.png',
    title: 'OnePlus Buds Z2',
    price: 4799,
    category: 'earphone',
    rating: '4.0',
    description:
      'Up to 40 dB noise cancelling with 2 modes - Faint (+/- 25dB) & Extreme (+/- 40 dB) through manual adjustment via OnePlus mobile or HeyMelody App. 11mm dynamic drivers acoustically tuned for bigger, bolder beats with razor-sharp treble & Dolby atmos support delivers immersive, false-to-life sound using industry leading spatial audio. To keep your calls sounding smooth, the 3-MIC design trims down wind noise caused by air friction. It sharpens voice-pickup & cuts down surrounding noise for crystal clear speech. Enjoy up to 38 hours of music and a quick fast charging of 10 minutes for 5 hours of playtime. Your winning advantage starts here with latency as low as 94ms, with Pro Gaming mode activated IP55 Water & Sweat Resistance',
    image: 'https://i.postimg.cc/Hx2rz9Z2/51-AMqyp-sf-L-AC-UL480-FMwebp-QL65.png',
  },
  {
    id: 'Auj5swnMVG',
    title: 'boAt Rockerz 245v2 ',
    price: 1399,
    category: 'earphone',
    rating: '4.2',
    description:
      'Rockerz 245v2 comes equipped with 12mm drivers for a thumping bass experience. This neckband can deliver upto 8 Hours of musical bliss. Battery Capacity (mAh): 100 mAh. The wireless neckband is lightweight in build and IPX5 rated for protection against sweat & water so that you can hit the gym or travel anywhere being carefree. The earbuds of this bluetooth neckband is magnetic. Note- they do not support play/pause function. Change tracks, volume and activate voice assistant with its integrated set of controls. Rockerz 245v2 comes with Bluetooth v5.0. Made to secure your movements as you shuck and jive to the beat, never lose a moment of satisfaction when you’re riding the waves high on you’re boAt Rockerz 245V2',
    image: 'https://i.postimg.cc/x8VSXwyp/51-E9-SIEocr-S-AC-UL480-FMwebp-QL65.png',
  },
  {
    id: 'GCTXpbFDFf',
    title: 'Boult Audio Airbass Z20 false Wireless',
    price: 1399,
    category: 'earphone',
    rating: '3.6',
    description:
      'Offers playback time of up to 10 hours for every charge. Carrying case can give 4 additional charges to the earbuds making total play-time of up to 40 Hours. Touch Controls & Voice Assistant: With one multifunction button, you can play/pause, previous/next track and answer/hang-up calls. Voice assistant function lets you access Siri/Google Assistant. Automatically pair with your device as soon as you take them out of the case. No need to manually pair to your device each time. IPX5 Water Resistant - Can comfortably be used in the outdoors or in the gym.',
    image: 'https://i.postimg.cc/fRL1RWQT/61y-Ea-Tpc-HTL-AC-UL480-QL65.png',
  },
  {
    id: 'rf6FZ4P0us',
    title: 'Bose Sport Earbuds',
    price: 15099,
    category: 'earphone',
    rating: '4.0',
    description:
      'Wireless Bluetooth earbuds engineered by Bose for your best workout yet.Bose lifelike sound—makes your music sound like the performer is right there beside you, pushing you to go one more mile or do one more rep. Secure and comfortable earbuds—customise your fit with the included 3 sizes of StayHear Max tips that won’t hurt your ears and won’t fall out no matter tough your workout is. Weather and sweat resistant earbuds—IPX4 rated, with electronics protected against splashing water wherever you exercise. Clear calls—a beamforming microphone array separates your voice from surrounding noise so your callers can hear you better.Instead of buttons, control your wireless earbuds with a series of simple gestures. On the right earbud, swipe up and down for optional volume control, double-tap to play or pause music and to answer calls. On the left earbud, double-tap to engage a Shortcut function like checking your battery level or skipping a track.',
    image: 'https://i.postimg.cc/TwR4BT06/51-P0-D-Zgy-VL-AC-UL480-QL65.png',
  },
  {
    id: 'MoXaDQxfA1',
    title: 'JBL Tune 760NC',
    price: 5390,
    rating: '4.2',
    category: 'headphone',
    description:
      'Tune out the Noise & Tune into your Music with JBL Tune 760NC wireless headset. These Bluetooth headphones reproduce that same JBL sound, punching out bass that’s both deep and powerful. Listen wirelessly for up to 35 hours with Active Noise Cancellation or up to 50 hours without Noise Cancellation for long-lasting fun. Recharge the battery quickly in 2 hours or enjoy endlessly in wired mode using the detachable AUX cable provided. Thanks to Fast Pair enabled by Google, the JBL Tune 760NC are immediately connected to your Android device. You can also pair multiple devices just by tapping on the devices’ screen. Allows you to effortlessly switch from one Bluetooth device to another. You can simply switch from a video on your tablet to a call on your mobile phone so that you’ll never miss a call. Easily control your music, manage your calls and trigger voice assistants from your headset with the buttons on your earcup. ',
    image: 'https://i.postimg.cc/W3Lk44KB/61-HXCeoz-Uj-L-AC-UL480-QL65.png',
  },
  {
    id: '6VMpbkkwkS',
    title: 'Bose Quietcomfort 45',
    price: 29900,
    rating: '4.8',
    category: 'headphone',
    description:
      'Iconic quiet. Comfort. And sound. The first noise cancelling headphones are back, now with lightweight materials for premium comfort and proprietary acoustic technology for deep, clear audio. They’re not just an icon reborn – they’re the perfect balance of quiet, comfort, and sound. The TriPort acoustic architecture offers depth and fullness. Volume-optimized Active EQ maintains balanced performance at any volume, so bass stays consistent when turned down and the music remains clear when turned up. Choose Quiet Mode for full noise cancelling, or Aware Mode to bring the outside into the around ear headphones and hear your environment and your music at the same time. These comfortable wireless headphones are suitable for all-day wear. Crafted with plush synthetic leather and impact-resistant nylon, and designed with minimal clamping force, they’re as luxurious as they are durable. Enjoy 24 hours of battery life from a single charge. A quick 15-minute charge offers 3 hours when you’re on the go, or plug in the included audio cable to listen for even longer in wired mode.',
    image: 'https://i.postimg.cc/sgBFjf59/51-Jbs-HSktk-L-AC-UL480-FMwebp-QL65.png',
  },
  {
    id: 'FSpfhWvcAh',
    title: 'boAt Rockerz 370',
    price: 2400,
    rating: '4.3',
    category: 'headphone',
    description:
      'Rockerz 370 offers a playback time of up to 12 hours.. Frequency Response 20Hz-20KHz,Sensitivity (dB) 79dB±3DB,Impedance 32Ω. It has Bluetooth v5.0 with a range of 10m and is compatible with Android & iOS. Lightweight Ergonomic Design with Easy Controls. Instant Voice Assistant. 40mm Drivers with boAt Signature Sound. Cozy Padded Earcups.',
    image:
      'https://i.postimg.cc/vBByb1HP/bo-At-Rockerz-370-Bluetooth-Headphones.png',
  },
  {
    id: 'BVH6RXmsTV',
    title: 'Sony Wh-Ch510',
    price: 4400,
    rating: '4.0',
    category: 'headphone',
    description:
      'Lightweight, all-day listening with quality sound. Listen to your favourite tracks wirelessly with a Bluetooth wireless technology by pairing your smartphone or tablet.With up to 35 hours of battery life, you’ll have enough power for even long trips away. Not only are the WH-CH510 headphones compact and lightweight, but the swivel earcups make it easy to safely pack them away in your bag. Use the buttons to play, stop, or skip through tracks and adjust the volume. Conversation flows freely with easy hands-free calling, thanks to the built-in microphone. No need to even take your phone from your pocket.',
    image:
      'https://i.postimg.cc/RCJFH84g/Sony-Wh-Ch510-Bluetooth-Wireless-Headphones.png',
  },
  {
    id: '1YfSc0VUW1',
    title: 'Sennheiser HD 450SE',
    price: 8990,
    rating: '3.8',
    category: 'headphone',
    description:
      'Bluetooth 5.0 technology for effortlessly reliable connectivity including AAC and AptX Low Latency codec support. Active noise cancellation (ANC) for uninterrupted listening pleasure. 30-hour battery life with USB-C fast charging. Intuitive controls including Virtual Assistant button for Alexa, Siri and Google Assistant',
    image: 'https://i.postimg.cc/gJLqj5N7/71j1dzy-RQPS-AC-UL480-FMwebp-QL65.png',
  },
  {
    id: 'CswqGabq8b',
    title: 'Boult Audio Probass Anchor Active',
    price: 3999,
    rating: '4.2',
    category: 'headphone',
    description:
      'Boults sound signature has been packed with extra punchy and deep bass with accentuates the warm midst and crytal sparky highs. 40m Transimission Distance. Unparalleled Comfort and Portable design. With ergonomic design and ultra-soft ear cups, our Bluetooth headphones ensure all-day listening comfort. Enjoy your music on the go. main focus on cancelling out lower frequency sounds like engines, aviation environment, trains, traffic noise etc. Give instructions to Siri and Google voice command with a simple 2 seconds click on Boult headphone. Anchor is a powerhouse. The run time is 30 hours and it has 5 days of standby.',
    image: 'https://i.postimg.cc/jqwtqXKJ/31-Sd4-H9c-Jl-L-AC-SR480-480.png',
  },
  {
    id: 'Az9w1uvzK7',
    title: 'Amazfit GTS2 Mini Smart Watch',
    price: 5499,
    outofStock: false,
    rating: '4.5',
    category: 'watch',
    description:
      'Monitoring your blood oxygen levels by intelligently monitoring your (SpO2) blood oxygen levels. 21 days Basic Usage Battery Life;Super-Light weight body with only 19.5 grams, 8.95 MM Thin body, comfortable to wear day & night and during sports activities. 1.55 AMOLED Display with high 314 PPI Resolution for a crystal clear image and sharp details.;70+ built-in sports modes and 5 ATM water-resistance. 24H Heart Rate Tracking, Female cycle tracking, Sleep quality monitoring, Stress level monitoring and BIO tracker 2 PPG. Bluetooth music control directly from your watch while exercise without having to pull out your phone.; Check Out Our Store : Click on the blue Amazfit link below the Product title, to explore our other models. ',
    image: 'https://i.postimg.cc/Y9Z3ZNbK/618-MEYCa-UQL-AC-UL480-FMwebp-QL65.png',
  },
  {
    id: 'xyS7xqHA2w',
    title: 'boAt Xtend Smartwatch',
    price: 2659,
    outofStock: false,
    rating: '4.0',
    category: 'watch',
    description:
      'Alexa built-in Voice Assistant that sets reminders, alarms and answers questions from weather forecasts to live cricket scores at your command. "1.69" big square colour LCD display with a round dial features complete capacitive touch experience to let you take control, effortlessly. Multiple watch faces with customizable options to match your OOTD, every day! The ambient light display allows automatic adjustment of brightness on the watch, suited to your environment. The watch comes with a stress monitor that reads your HR to indicate stress levels.It also monitors your heart rate and SpO2 (blood oxygen levels) to keep a tab on your overall health. Track all stages of sleep every night and keep a tab on your sleep health with the sleep monitoring feature on the watch. Its 14 sports mode and 5 ATM dust, splash and sweat resistance makes it the perfect fitness companion to have.',
    image: 'https://i.postimg.cc/zBBXLKCQ/61-IMRs-o0i-L-AC-UY327-QL65.png',
  },
  {
    id: 'IRQJCIC0eR',
    title: 'Fire-Boltt Phoenix Smart Watch',
    price: 1998,
    rating: '4.5',
    category: 'watch',
    description:
      'Fire-Boltt Phoenix enables you to make and receive calls directly from your watch via the built-in speaker and microphone. This smartwatch features a dial pad, option to access recent calls & sync your phone’s contacts.;【High Resolution Display】- Comes with a 1.3" TFT Color Full Touch Screen and a 240*240 Pixel High Resolution this watch is covered to flaunt the sleek and stylish look always. Track each activity effectively with this smartwatch & activity tracker. Track your calories, steps and much more while you are on your fitness journey. This fitness tracker has it all. Get HD calling experience with this power-packed watch. Enhance the look of your wrist with attractive colors and sleek finish. With the latest HRS3300 technology track your heart rate anytime of the day or even while you perform some activity. The optical sensors assure results so accurate. Monitor your blood oxygen levels to stay fit and healthy;【Smartphone Notifications】- Get all your mobile phone notifications on this 1.3" Round Display Full touch smartwatch and never be late for a meeting, party or date.',
    image: 'https://i.postimg.cc/wMQJ6hgG/61y2-VVWc-GBL-AC-UY327-QL65.png',
  },
  {
    id: 'sLbKcioPdd',
    title: 'Noise ColorFit Pro 4',
    price: 3499,
    rating: '4.0',
    category: 'watch',
    description:
      'Advanced Bluetooth calling: Upgrade to an effortless calling experience - attend/reject calls and dial numbers, from your wrist.;Navigate through the watch, adjust volume and change the watch face via the fully-functional crown. 1.72 display: ColorFit Pro 4 features 1.72 TFT LCD with 25% more screen area than ColorFit Pro 3.;Vivid clarity: View information under the brightest sun, thanks to 311 PPI and 500 nits of brightness. 60Hz refresh rate: Get smoother scrolling & navigation experience.;100 sports modes: Take your pick from 100 sports modes and ace your game. Noise Health Suite: Know how your body is doing with the battery of fitness features.;Productivity suite: Get more work done with quick reply options, stock market updates, alarm and disconnect with smart DND when you want to.; Water Resistance Level: Water Resistant',
    image: 'https://i.postimg.cc/bwc5sP0c/61u2dh-Y-JBL-AC-UL480-FMwebp-QL65.png',
  },
  {
    id: 'q57k7vuFMT',
    title: 'GIONEE STYLFIT GSW6 Smartwatch',
    price: 1627,
    rating: '3.0',
    category: 'watch',
    description:
      '4.3cm Full touch display. Zinc Alloy Body;Bluetooth for Calling & Music & Built-in Mic & Speaker & IP68. Wellness Modes: Blood Oxygen Monitor (SpO2), 24x7 Heart Rate Monitor, Sleep Monitor, Multiple Sport Mode, Calorie Meter & Pedometer, Menstrual Tracker. 100+ Cloud Based Watch Faces & Customized watch face; Remote Camera, & Notifications Alert for Calls, WhatsApp, SMS, eMail & Facebook etc. Fitness & Outdoor & Battery Runtime: Up to 3 Days, Battery capacity : 220 mAh',
    image: 'https://i.postimg.cc/TPw2HnKc/61-GYLDLq-Xx-L-AC-UL480-FMwebp-QL65.png',
  },
  {
    id: 'bf22BjtlNl',
    title: 'TAGG Kronos Lite Full Touch Smartwatch',
    price: 1399,
    rating: '4.0',
    category: 'watch',
    description:
      'TAGG Kronos Lite Round Smart watch comes with 1.3” Large & Crystal HD Display with Live Wallpapers.TAGG Kronos Lite comes with 24*7 real time heart rate, Spo2 Sleep Cycle, Breath mode and Female Menstrual Tracking. Helps you to keep a track of your workout and the Activity Map. Never miss out on any message or call or any other important notifications. Get water drinking reminders and sedentary reminders to make sure that you stay hydrated and active the whole day. We make sure that nothing comes between you and your health.',
    image: 'https://i.postimg.cc/mkDWYp4s/71-L4-COcbwu-L-AC-UL480-FMwebp-QL65.png',
  },
];
